import React from 'react';
import { createRoot } from 'react-dom/client';
import './i18n';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Config from './config.json'

if(Config.hasOwnProperty('LOCAL_API_URL')){
  window.__API_URL__ = (Config as any).LOCAL_API_URL
} else if (window.location.host.split(".")[0] === "app") {
  window.__API_URL__ = "https://api.rockstar.jobs/candy"
} else {
  window.__API_URL__ = "https://api-staging.rockstar.jobs/candy"
}

const root = createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  //<React.StrictMode>
  <App />
  //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
